import { c as _c } from "react/compiler-runtime";
import type { StructuredContentDocument } from '../../hydration/types';
import type { VideoSCProps } from './types';
import { Video as VideoClient } from './Video.client';
export const Video = t0 => {
  const $ = _c(4);
  const {
    type,
    version,
    props
  } = t0;
  let t1;
  if ($[0] !== props || $[1] !== type || $[2] !== version) {
    t1 = <VideoClient type={type} version={version} props={props} />;
    $[0] = props;
    $[1] = type;
    $[2] = version;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};